import { useEffect, useState } from 'react';

// debug-enhanced serviceWorkerRegistration.js
let __swRegistration = null;
export const getSWRegistration = () => __swRegistration;

const SW_VERSION_ALERT_KEY = "__CHOIRPLAYER_VERSION_ALERT_SHOWN__";

export function showNewVersionAlertOnce(source = "unknown") {
  // pgw 17-may-2026
  // Do NOT show the old service-worker update alert from choir-player-web.
  // App update prompting is now owned by the remote version check in:
  //   vendor/player-application/utils/appVersionCheck.js
  // This function is kept as a no-op logger so older code paths do not crash.
  console.log("[SW] old service-worker update alert suppressed from", source);
}

export async function checkForServiceWorkerUpdate(source = "manual") {
  if (!("serviceWorker" in navigator)) return false;

  try {
    const reg = __swRegistration || await navigator.serviceWorker.getRegistration();

    if (!reg) {
      console.log("[SW] no registration found during update check", source);
      return false;
    }

    console.log("[SW] checking for update", {
      source,
      scope: reg.scope,
      waiting: !!reg.waiting,
      installing: !!reg.installing,
      active: !!reg.active,
    });

    await reg.update();

    if (reg.waiting) {
      console.log("[SW] service-worker update detected but old alert is suppressed", source);
      return true;
    }

    return false;
  } catch (e) {
    console.warn("[SW] update check failed", source, e);
    return false;
  }
}

window.__CP_CHECK_FOR_UPDATE__ = checkForServiceWorkerUpdate;

// pgw 25-sep-2025 - never called as far as i can tell
/*
const waitForControllerChange = () =>
  new Promise((resolve) => {
    const onChange = () => {
      navigator.serviceWorker.removeEventListener('controllerchange', onChange);
      console.log('[SW v525][page] controllerchange — new SW now controls this page');
      resolve();
    };
    navigator.serviceWorker.addEventListener('controllerchange', onChange);
  });
*/

// serviceWorkerRegistration.js (or where you wire it)
export function register({ onSuccess, onUpdate } = {}) {

console.log("choir-player-web/src/serviceWorkerRegistration.js register p1");

  if (!('serviceWorker' in navigator)) return;

  (async () => {
	const reg = await navigator.serviceWorker.register('/service-worker.js');
	__swRegistration = reg;


    // If an update is already waiting, fire onUpdate now

	if (reg.waiting) {
	  console.log("[SW] service-worker waiting; old update UI suppressed");
	}

    reg.addEventListener('updatefound', () => {
      const nw = reg.installing;
      if (!nw) return;
      nw.addEventListener('statechange', () => {
        if (nw.state === 'installed') {
          // Only call onUpdate if it's *actually waiting*

		  if (reg.waiting) {
			console.log("[SW] service-worker updatefound; old update UI suppressed");
		  } else {
			onSuccess?.(reg);
		  }

        }
      });
    });

    // When a new SW takes control, clear the banner
    navigator.serviceWorker.addEventListener('controllerchange', () => {

		console.log("choir-player-web/src/serviceWorkerRegistration.js controllerchange p1");

      // e.g. dispatch(clearSwUpdate()) or hide banner
      // console.log('[SW v525][page] controllerchange – clear any “update” UI');
    });
  })().catch(e => console.error('[SW v525] register failed', e));
}

/*
export function register({ onSuccess, onUpdate } = {}) {
  if (!('serviceWorker' in navigator)) return;

  (async () => {
    try {
      const reg = await navigator.serviceWorker.register('/service-worker.js');

      reg.addEventListener('updatefound', () => {
        const newSW = reg.installing;
        if (!newSW) return;

        newSW.addEventListener('statechange', () => {
          // Only consider it an update if it's now WAITING
          if (newSW.state === 'installed') {
            // Chrome will set reg.waiting when a previous controller exists
            if (reg.waiting) {
              // ✅ Real update available
              onUpdate?.(reg);
            } else {
              // First install (no previous SW)
              onSuccess?.(reg);
            }
          }
        });
      });

      // Also handle the edge case where an update was already in 'waiting'
      if (reg.waiting) {
        onUpdate?.(reg);
      }
    } catch (e) {
      console.error('[SW v525] register failed', e);
    }
  })();
}
*/


/*
// src/serviceWorkerRegistration.js
export function register({ onSuccess, onUpdate } = {}) {
  if (!('serviceWorker' in navigator)) return;

  (async () => {
    try {
      const reg = await navigator.serviceWorker.register('/service-worker.js');

      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        // console.log('[SW v525][page] updatefound; installing exists?', !!nw);
        if (!nw) return;

        nw.addEventListener('statechange', () => {
          // console.log('[SW v525][page] installing.state =', nw.state);
          if (nw.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            // console.log('[SW v525][page] new version installed and waiting');
            onUpdate?.({
              scope: reg.scope,
              hasUpdate: true,
              waiting: !!reg.waiting,
            });
          } else {
            // console.log('[SW v525][page] first install complete');
            onSuccess?.({
              scope: reg.scope,
              hasUpdate: false,
              waiting: !!reg.waiting,
            });
          }
        });
      });

    } catch (e) {
      console.error('[SW v525] register failed', e);
    }
  })();
}
*/

// Changed this so that it does not wait for window.load
/*
export function register({ onSuccess, onUpdate } = {}) {
  if (!('serviceWorker' in navigator)) {
    // console.log('[SW v525][page] serviceWorker not supported');
    return;
  }

  window.addEventListener('load', async () => {
    try {
      // console.log('[SW v525][page] registering /service-worker.js ...');
      const reg = await navigator.serviceWorker.register('/service-worker.js');
      __swRegistration = reg;

      // console.log('[SW v525][page] registration:', {
        scope: reg.scope,
        active: !!reg.active,
        installing: !!reg.installing,
        waiting: !!reg.waiting,
      });

      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        // console.log('[SW v525][page] updatefound; installing exists?', !!nw);
        if (!nw) return;

        nw.addEventListener('statechange', () => {
          // console.log('[SW v525][page] installing.state =', nw.state);
          if (nw.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            // console.log('[SW v525][page] new version installed and waiting');
            onUpdate?.({
              scope: reg.scope,
              hasUpdate: true,
              waiting: !!reg.waiting,
            });
          } else {
            // console.log('[SW v525][page] first install complete');
            onSuccess?.({
              scope: reg.scope,
              hasUpdate: false,
              waiting: !!reg.waiting,
            });
          }
        });
      });
    } catch (e) {
      console.error('[SW v525][page] register failed', e);
    }
  });
}
*/


export async function forceUpdateSW({ reload = true, timeoutMs = 10000 } = {}) {
  if (!('serviceWorker' in navigator)) return { ok: false, reason: 'no-sw' };

  const regs = await navigator.serviceWorker.getRegistrations();
  const reg = regs[0];
  if (!reg) return { ok: false, reason: 'no-registration' };

  // console.log('[SW v525][page] forceUpdateSW: calling reg.update()');
  try {
    await reg.update(); // fetch latest sw.js
  } catch (e) {
    console.warn('[SW v525][page] reg.update() failed', e);
  }

  // Ensure we address the *waiting* worker.
  let waiting = reg.waiting;

  // If still installing, wait for it to become installed/waiting.
  if (!waiting && reg.installing) {
    // console.log('[SW v525][page] waiting for installing -> installed');
    waiting = await new Promise((resolve) => {
      const i = reg.installing;
      const onState = () => {
        if (i.state === 'installed') {
          i.removeEventListener('statechange', onState);
          resolve(reg.waiting || i); // reg.waiting preferred
        }
      };
      i.addEventListener('statechange', onState);
    });
  }

  if (!waiting) {
    // Nothing to activate — either already on latest, or the new SW hasn’t installed yet.
    // console.log('[SW v525][page] no waiting worker (already latest?)');
    return { ok: true, reason: 'no-waiting' };
  }

  // Post SKIP_WAITING ONLY to the waiting/ installing worker.
  // console.log('[SW v525][page] posting SKIP_WAITING to waiting');
  waiting.postMessage({ type: 'SKIP_WAITING' });

  if (!reload) return { ok: true, reason: 'skip-no-reload' };

  // Wait for controller to change (new SW takes control).
  const controllerChanged = new Promise((resolve) => {
    const onChange = () => {
      navigator.serviceWorker.removeEventListener('controllerchange', onChange);
      resolve(true);
    };
    navigator.serviceWorker.addEventListener('controllerchange', onChange);
  });

  // Add a timeout so UI doesn't hang forever.
  const timeout = new Promise((resolve) =>
    setTimeout(() => resolve(false), timeoutMs)
  );

  const changed = await Promise.race([controllerChanged, timeout]);

  if (changed) {
    // console.log('[SW v525][page] controller changed — reloading');
    window.location.reload();
    return { ok: true };
  } else {
    console.warn('[SW v525][page] controllerchange timed out');
    // As a last resort, a manual reload can still pick up the new SW after activation.
    return { ok: false, reason: 'controllerchange-timeout' };
  }
}


/*
export async function forceUpdateSW({ reload = true } = {}) {
  if (!('serviceWorker' in navigator)) return { ok: false, reason: 'no-sw' };

  const reg = __swRegistration || (await navigator.serviceWorker.getRegistration());
  if (!reg) {
    console.warn('[SW v525][page] no registration found in forceUpdateSW');
    return { ok: false, reason: 'no-registration' };
  }

  // console.log('[SW v525][page] forceUpdateSW: calling reg.update()');
  await reg.update();

  const target = reg.waiting || reg.installing || reg.active;
  if (target?.postMessage) {
    // console.log('[SW v525][page] posting SKIP_WAITING to', target.state || '(no-state)');
    target.postMessage({ type: 'SKIP_WAITING' });
  } else {
    // console.log('[SW v525][page] no target to postMessage');
  }

  if (navigator.serviceWorker.controller) {
    await waitForControllerChange();
    if (reload) {
      // console.log('[SW v525][page] reloading after controllerchange');
      window.location.reload();
    }
    return { ok: true, activated: true };
  }

  if (reload) {
    // console.log('[SW v525][page] no controller yet (first install); reloading');
    window.location.reload();
  }
  return { ok: true, activated: false };
}
*/


// pgw 25-sep-2025 - never called as far as i can tell
/*
export function useServiceWorkerUpdater() {
  const [updateReady, setUpdateReady] = useState(false);

  useEffect(() => {
    register({
      onUpdate: () => setUpdateReady(true),
      onSuccess: () => setUpdateReady(false),
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then(reg => {
        // console.log('[SW v525][page] initial getRegistration:', !!reg, reg?.scope);
      });
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // console.log('[SW v525][page] controllerchange (hook observer)');
      });
    }
  }, []);

  return { updateReady, forceUpdate: forceUpdateSW };
}
*/
